import { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
    {
        path: '',
        name: 'main-layout',
        component: () => import('@/layouts/main/MainLayout.vue'),
        children: [],
    },
];
